export const ErrorCode = {
  NO_LOGIN: -2,
  NO_ACCOUNT_RIGHT: -7,
  ACCOUNT_NOT_EXIST: -5,
  AGENCY_REJECT: -6,
  WECHAT_NOT_AUTHORIZE: -8,
  SECOND_NOT_LOGIN: -9,
};
